import React from 'react'
import { Stock } from '../types'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

interface ProductStockProps {
    stocks: Stock[]
}

const ProductStock: React.FC<ProductStockProps> = props => {
    if (props.stocks.length <= 0) {
        return null
    }

    return (
        <div className="grid__col--10 grid__col--offset-1 grid__col--spacing grid__col--spacing-bottom-2x">
            <div className="product product--border product--direction-col">
                <div className="product__title">
                    <i className="fal fa-dolly-flatbed-alt product__icon"/>
                    <FormattedMessage
                        id="stock"
                    />
                </div>
                <div className="product__info product__info--full-width">
                    {props.stocks.map(stock => (
                        <div
                            key={stock.name}
                            className={classNames('tag', [`tag--${stock.stock > 0 ? 'success' : 'error'}`])}
                        >
                            <strong className="tag__bold">{stock.stock}</strong> {stock.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ProductStock